<div class="container-fluid">
  <app-header titleText="Admin">
  </app-header>
  <div class="card bg-light">
    <div class="card-header">
      <h3>IDI Users</h3>
      <div>
        <span>IDI Users define people that have been granted the ability to add/edit dealers and view analytical data on those users</span>
        <span class="float-right">
          <button (click)="showEdit(null)" class="btn btn-bidit-navigate btn-md">Add User</button>
        </span>
      </div>
    </div>
    <div class="card-body">
        <!--<form #form="ngForm" (ngSubmit)="searchUserss(form)" class="form-inline float-right mb-3">
      <input id="searchText" name="searchText" class="form-control mr-sm-2" [(ngModel)]="searchText">
      <button class="btn btn-bidit-action btn-md" type="submit"> Apply Filter</button>
    </form>-->
        <mat-table class="table table-bidit table-striped table-hover" [dataSource]="dataSource"
                   matSort matSortActive="userName" matSortDirection="asc">
            <ng-container matColumnDef="userName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Name</mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{user.firstName}} {{user.lastName}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="phone">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Phone</mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{user.phoneNumber}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Email</mat-header-cell>
                <mat-cell *matCellDef="let user">
                    {{user.email}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef class="bidit-header" i18n></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div class="form-inline">
                        <label id="user_status_active{{user.id}}" [ngClass]="{'text-success' : user.isActive}">active</label>
                        <input (change)="toggleStatus(user.id)" type="checkbox" name="dealer_status_{{user.id}}" id="user_status_{{user.id}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!user.isActive" (ngModelChange)="user.isActive = $event">
                        <label id="user_status_inactive{{user.id}}" [ngClass]="{'text-danger' : !user.isActive}">inactive</label>
                        <a class="btn-bidit-edit-dark ml-4" (click)="showEdit(user.id)"></a>
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <mat-paginator [length]="users?.length" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>
